

















































































































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import DateFormat from '@/shared/utils/date-format';
import MainButton from '@/shared/buttons/main-button.component.vue';
import CustomerPickerComponent from '@/shared/customer-picker/customer-picker.component.vue';
import VueToExcel from 'vue-json-excel';
import BillableItemsFilter from '@/domain/contract/entity/billable-items-filter.entity';
import BillableItems from '@/domain/contract/entity/billable-items.entity';

@Component({
  components: { MainButton, CustomerPickerComponent, VueToExcel },
})
export default class BillableItemsFilterComponent extends Vue {
  @Prop({
    required: true,
    default: '',
  })
  private businessUnitId!: string;

  @Prop({
    required: false,
  })
  private incomingFilter?: BillableItemsFilter;

  @Prop({
    required: false,
  })
  private billableItems!: BillableItems[];

  locale = 'pt-BR';

  filter: BillableItemsFilter = BillableItemsFilter.of({});

  ref: any = this.$refs;

  selectedCompetenceDate: string = '';

  lastFilteredName: string = '';

  get processingCount() {
    return this.billableItems.length !== 0
      ? this.billableItems[0].processing
      : 0
  }

  @Watch('incomingFilter')
  updateFilter() {
    if (this.incomingFilter && this.incomingFilter.competence) {
      this.selectedCompetenceDate = DateFormat.localToDate(this.incomingFilter.competence);
    }
  }

  private formatDate(date: string): string {
    if (date) {
      return DateFormat.timestampToLocal(date);
    }
    return '';
  }

  send() {
    if (this.selectedCompetenceDate) {
      this.filter.competence = DateFormat.localDateToLocal(this.selectedCompetenceDate);
    }
    this.$emit('filter', this.filter);
  }

  clear() {
    this.ref.form.reset();
    this.filter = new BillableItemsFilter({});
    this.selectedCompetenceDate = '';
  }

  get competenceDateText() {
    return DateFormat.fullMonthAndYear(DateFormat.localDateToLocal(this.selectedCompetenceDate));
  }

  csvLabel = {
    'ID Contrato': 'contractVersionId',
    'N. Contrato': 'contractNumber',
    Item: 'itemNumber',
    Cliente: 'customerName',
    Beneficiário: 'beneficiaryName',
    Competência: 'formattedCompetence',
    'Início Faturamento': 'formattedBillingStartCompetence',
    Descrição: 'description',
  }

  created(): void {
    this.updateFilter();
  }
}
